<template>
  <v-data-table
    class="table row-click mods-list"
    :headers="headers"
    :items="items"
    :options.sync="innerOptions"
    :server-items-length="total"
    item-key="id"
    show-select
    :disable-sort="!sortable"
    :value="selected"
    :loading="loading"
    hide-default-footer
    @input="$emit('update:selected', $event)"
    @click:row="onRowClick"
  >
    <template v-slot:item.id="{ item }">
      <span class="mods-list__id">{{ item.id }}</span>
    </template>
    <template v-slot:item.address="{ item }">
      <div class="d-flex align-center">
        <v-icon x-small color="primary" class="mr-1">mdi-map-marker-outline</v-icon>
        <span>{{ item.address }}</span>
      </div>
    </template>
    <template v-slot:item.model="{ item }">
      <v-chip x-small label color="blue-grey lighten-5" text-color="blue-grey darken-2">
        <v-icon left x-small>mdi-memory</v-icon>
        {{ item.model || '—' }}
      </v-chip>
    </template>
    <template v-slot:item.physical_status="{ item }">
      <div class="d-flex align-center">
        <v-icon x-small :color="physicalStatusColor(item.physical_status)" class="mr-1">
          mdi-checkbox-blank-circle
        </v-icon>
        {{ physicalStatus(item.physical_status) }}
      </div>
    </template>
    <template v-slot:no-data>
      <div class="py-8 text-center grey--text">
        <v-icon large color="grey lighten-1" class="mb-2">mdi-doorbell-video-off</v-icon>
        <div>Нет домофонов по текущим фильтрам</div>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import StatusIntercomMixin from '@/mixins/StatusIntercomMixin';

export default {
  name: 'MassOpenDoorSoundList',
  mixins: [StatusIntercomMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    options: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hideRegion: {
      type: Boolean,
      default: false,
    },
    sortable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    headers () {
      const sortable = this.sortable;
      const headers = [
        { text: 'ID', value: 'id', width: 80, sortable },
        { text: 'Адрес', value: 'address', sortable: false },
      ];
      if (!this.hideRegion) {
        headers.push({ text: 'Район', value: 'region', sortable: false });
      }
      headers.push(
        { text: 'Модель', value: 'model', sortable },
        { text: 'Статус', value: 'physical_status', sortable },
        { text: 'УК', value: 'management_company', sortable: false },
      );
      return headers;
    },
    innerOptions: {
      get () {
        return this.options;
      },
      set (val) {
        this.$emit('update:options', val);
      },
    },
  },
  methods: {
    onRowClick (item, slot) {
      const event = slot && slot.event;
      if (this.hasTextSelection()) {
        return;
      }
      if (this.isCheckboxClick(event)) {
        return;
      }
      this.toggleItem(item);
    },
    hasTextSelection () {
      if (typeof window === 'undefined' || !window.getSelection) {
        return false;
      }
      return String(window.getSelection()).length > 0;
    },
    isCheckboxClick (event) {
      const target = event && event.target;
      if (!target || !target.closest) {
        return false;
      }
      return !!(
        target.closest('.v-data-table__checkbox') || target.closest('.v-simple-checkbox') || target.closest('input[type="checkbox"]')
      );
    },
    toggleItem (item) {
      const next = [...(this.selected || [])];
      const index = next.findIndex((row) => row.id === item.id);
      if (index === -1) {
        next.push(item);
      } else {
        next.splice(index, 1);
      }
      this.$emit('update:selected', next);
    },
  },
};
</script>

<style scoped>
.mods-list ::v-deep tbody tr {
  cursor: pointer;
}
.mods-list ::v-deep tbody tr,
.mods-list ::v-deep tbody td {
  user-select: text;
}
.mods-list__id {
  font-family: monospace;
  font-size: 0.85rem;
  color: #546e7a;
}
</style>
